import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import CannabisLoader from './CannabisLoader';
import '../ShefaAppBoot.css';

/**
 * Полноэкранный оверлей для разделов (z-index 9998, ниже глобального бут-лоадера 9999).
 * @param {object} props
 * @param {boolean} props.show
 * @param {number} [props.progress] — если не передан, при show крутится имитация до ~90, при hide → 100
 */
export default function ShefaPageLoadOverlay({ show, progress: progressProp }) {
  const [internal, setInternal] = useState(0);

  const controlled = typeof progressProp === 'number';

  useEffect(() => {
    if (!show) {
      if (!controlled) setInternal(100);
      return undefined;
    }
    if (controlled) return undefined;
    setInternal(15);
    const i = setInterval(() => {
      setInternal((p) => (p < 92 ? Math.min(92, p + 4 + Math.random() * 5) : p));
    }, 350);
    return () => clearInterval(i);
  }, [show, controlled]);

  const progress = controlled ? progressProp : internal;

  if (!show) return null;

  return createPortal(
    <div
      className="shefa-page-load-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <CannabisLoader progress={progress} fullScreen />
    </div>,
    document.body
  );
}
